import http from "./https";


export const getCustomerList = async (queryString) => {
  let url = queryString ? "/customer?" + queryString : "/customer";
  const { data } = await http.get(url);
  localStorage.setItem("customers", JSON.stringify(data));
  return data?.results;
};

export const getCustommerByQueryString = async (queryString) => {
  const response = await http.get(`/customer?${queryString}`
  );

  return response.data;
};
